import { apiClient, type PageEnvelope } from '@/lib/api-client';

export interface AttachmentRow {
  id: string;
  filename: string;
  mime_type: string;
  size_bytes: number;
  created_at: string;
}

export const attachmentsApi = {
  list: () =>
    apiClient
      .get<PageEnvelope<AttachmentRow>>('/api/v1/attachments')
      .then((r) => r.items),
  /**
   * Upload one file. Uses fetch() directly instead of the axios client so
   * we can send FormData without axios stripping the boundary header.
   */
  upload: async (file: File): Promise<AttachmentRow> => {
    const fd = new FormData();
    fd.append('file', file);
    const resp = await fetch('/api/v1/attachments', {
      method: 'POST',
      body: fd,
      credentials: 'include',
    });
    if (!resp.ok) {
      let msg = `Upload failed (${resp.status})`;
      try {
        const body = (await resp.json()) as { error?: { message?: string } };
        if (body?.error?.message) msg = body.error.message;
      } catch {
        /* body wasn't JSON */
      }
      throw new Error(msg);
    }
    return (await resp.json()) as AttachmentRow;
  },
  remove: (id: string) => apiClient.del<void>(`/api/v1/attachments/${id}`),
  downloadUrl: (id: string) => `/api/v1/attachments/${id}/download`,
};
